import * as Attribution from './driftrock_attribution';
import * as Banner from './widgets/banner';
import * as FormHelpers from './forms/helpers';
import * as Inline from './widgets/inline';
import * as Launcher from './widgets/launcher';
import * as Modal from './widgets/modal';
import * as Widget from './widgets/base';

function loadWidgets() {
  const url = document.location.href;

  return fetch(`${Driftrock.settings.base_url}/v2/widget_config_new`, {
    headers: {
      "Accept": "application/json",
      "Authorization": `Bearer ${Driftrock.settings.api_key}`,
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify({ url: url, entity_version: Driftrock.widget_settings.entity_version , display_tech: Driftrock.widget_settings.display_tech}),
  }).then(FormHelpers.handleApiError)
    .then(response => response.json())
    .then(json_response => json_response.data)
}

function show_widget_by_id(widget_id) {
  if (widget_id) {
    Widget.show(Driftrock.widget_configs[widget_id]);
  }
}

function hide_widget_by_id(widget_id) {
  if (widget_id) {
    Widget.hide(Driftrock.widget_configs[widget_id]);
  }
}

function initWidgets(configs) {
  var configs_map = {};

  configs.forEach(config => {
    configs_map[config.widget.id] = config;

    switch (config.widget.format_config.type) {
    case "banner":
      Banner.init(config)
      break;
    case "inline":
      Inline.init(config)
      break;
    case "launcher":
      Launcher.init(config)
      break;
    case "modal":
      Modal.init(config)
      break;
    default:
      console.log(`Format type ${config.widget.format_config.type} not supported yet`)
    }
  });

  Driftrock.widget_configs = configs_map;

  return configs;
}

export function init (init_config) {
  if (Driftrock.settings.debug) {
    console.info("[Driftrock] Initialising widget");
  }

  window.Driftrock.show_widget = (widget_id) => show_widget_by_id(widget_id);
  window.Driftrock.hide_widget = (widget_id) => hide_widget_by_id(widget_id);

  loadWidgets()
    .then(initWidgets)
}
